<script>
  import Sections from "../../../components/layout/Sections.svelte";
  import Subsection from "../../../components/layout/Subsection.svelte";
  import SubsectionTitle from "../../../components/layout/SubsectionTitle.svelte";
  import { translate } from "../../../i18n/i18next.js";

  export let licenseData
</script>


<Sections>
  {#if licenseData.plan}
    <Subsection>
      <SubsectionTitle>{translate("generic.username")}: {licenseData.username ?? "-"}</SubsectionTitle>
    </Subsection>
  {/if}
  <Subsection>
    <SubsectionTitle>
      {translate("frontend:pages.admin.server.sections.license.currentPlan.title")}
      {licenseData.plan
        ? translate(`mySchedule.plans.${licenseData.plan}.name`)
        : translate(`mySchedule.plans.free.name`)}
    </SubsectionTitle>
    {#if !licenseData.plan}
      <div class="offset">
        {translate("frontend:pages.admin.server.sections.license.currentPlan.captionFreePlan")}
      </div>
    {/if}
    {#if licenseData.plan === "viewer"}
      <div class="offset">
        {translate("frontend:pages.admin.server.sections.license.currentPlan.captionViewerPlan")}
      </div>
    {/if}
    {#if licenseData.plan === "standard"}
      <div class="offset">
        {translate("frontend:pages.admin.server.sections.license.currentPlan.captionStandardPlan")}
      </div>
    {/if}
    <div class="offset">
      <a href={translate("frontend:pages.admin.server.sections.license.currentPlan.captionPlanComparisonHref")} style="text-decoration: underline" target="_blank">
        {translate("frontend:pages.admin.server.sections.license.currentPlan.captionPlanComparison")}
      </a>
    </div>
  </Subsection>
  {#if licenseData.type}
    <Subsection>
      <SubsectionTitle>
        {translate("generic.license.type")}:
        {translate(`generic.license.types.${licenseData.type}`)}
      </SubsectionTitle>
    </Subsection>
  {/if}
  {#if licenseData.plan === "standard" || licenseData.plan === "viewer"}
    <Subsection>
      <SubsectionTitle>{translate("generic.license.serialNumber")}: {licenseData.serialNumber}</SubsectionTitle>
    </Subsection>
  {/if}
  <Subsection>
    {#if licenseData.standardPlanProjects && licenseData.standardPlanProjects > 0}
      <SubsectionTitle>
        {translate("frontend:pages.admin.server.sections.license.standardPlanProjects.title", null, {count: licenseData.standardPlanProjects})}
      </SubsectionTitle>
      <div class="offset">
        {translate("frontend:pages.admin.server.sections.license.standardPlanProjects.caption")}
      </div>
    {/if}
    {#if licenseData.viewerPlanProjects && licenseData.viewerPlanProjects > 0}
      <SubsectionTitle>
        {translate("frontend:pages.admin.server.sections.license.viewerPlanProjects.title", null, {count: licenseData.viewerPlanProjects})}
      </SubsectionTitle>
      <div class="offset">
        {translate("frontend:pages.admin.server.sections.license.viewerPlanProjects.caption")}
      </div>
    {/if}
    <SubsectionTitle>
      {translate("frontend:pages.admin.server.sections.license.freePlanProjects.title")}
    </SubsectionTitle>
    <div class="offset">
      {translate("frontend:pages.admin.server.sections.license.freePlanProjects.caption")}
    </div>
  </Subsection>
  <Subsection>
    <SubsectionTitle>
      {translate("frontend:pages.admin.server.sections.license.maxCCUs.title", null, {count: licenseData.maxCCU ?? 1})}
    </SubsectionTitle>
    {#if !licenseData.plan}
      <div class="offset">
        {translate("frontend:pages.admin.server.sections.license.maxCCUs.captionFreePlan")}
      </div>
    {:else}
      <div class="offset">
        {translate("frontend:pages.admin.server.sections.license.maxCCUs.captionPaidPlan.1")}
      </div>
      <div class="offset">
        {translate("frontend:pages.admin.server.sections.license.maxCCUs.captionPaidPlan.2")}
      </div>
    {/if}
  </Subsection>
  {#if licenseData.validityPeriod}
    <Subsection>
      <SubsectionTitle>
        {translate("frontend:pages.admin.server.sections.license.validityPeriod.title", null, {start: licenseData.validityPeriod.start, end: licenseData.validityPeriod.end})}
      </SubsectionTitle>
    </Subsection>
  {/if}
  <Subsection>
    <SubsectionTitle>
      <div style="display: flex; gap: 2rem">
        <div>
          {translate("frontend:pages.admin.server.sections.license.authenticationMethod.title")}:
          {#if licenseData.authMethod === "eProtector"}
            {translate("generic.license.protectors.eProtector")}
          {/if}
          {#if licenseData.authMethod === "invalidEProtector"}
            {translate("generic.license.protectors.eProtector")} ({translate("generic.invalid")})
          {/if}
          {#if licenseData.authMethod === "online"}
            {translate("generic.license.protectors.online")}
          {/if}
          {#if licenseData.authMethod === "none"}
            {translate("generic.license.protectors.none")}
          {/if}
          {#if licenseData.authMethod === "dev"}
            dev
          {/if}
        </div>
      </div>
    </SubsectionTitle>
  </Subsection>
</Sections>

<style>
  .offset {
    padding-left: .5rem;
  }
</style>
